import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaCollapse from './VaCollapse.vue'

export default withConfigTransport(VaCollapse)
